import React, { useState, useEffect, createContext, useContext } from "react";
import axios from "axios";

const AuthContext = createContext(null);
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(() => localStorage.getItem("eu_admin_token"));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const check = async () => {
      if (!token) { setLoading(false); return; }
      try {
        const res = await axios.get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } });
        setUser(res.data);
      } catch {
        localStorage.removeItem("eu_admin_token");
        setToken(null);
      }
      setLoading(false);
    };
    check();
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    localStorage.setItem("eu_admin_token", res.data.token);
    setToken(res.data.token);
    setUser({ email: res.data.email, name: res.data.name });
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem("eu_admin_token");
    setToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, token, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
